import { buildDurationTypeLabels, OPPORTUNITY_TYPE_CONFIG } from '../../model/constants';
import type { DurationTypeValue } from '../../model/types';

export function OpportunityTypeBadge({ type }: { type: DurationTypeValue }) {
  const { bg, text, Icon } = OPPORTUNITY_TYPE_CONFIG[type];
  return (
    <span
      className={`inline-flex w-fit items-center gap-1 px-2 py-1 rounded-sm text-xs whitespace-nowrap ${bg} ${text}`}
    >
      <Icon className="size-3 shrink-0" />
      {buildDurationTypeLabels()[type]}
    </span>
  );
}
